import React from 'react';
import { ActivityIndicator as NativeActivityIndicator } from 'react-native';
import { useDripsyTheme } from '../use-dripsy-theme';
import { useSx } from '../use-sx';
function Indicator(props) {
    const { colors } = useDripsyTheme().theme;
    const sx = useSx();
    let { color } = props;
    if (typeof color === 'string' && colors?.[color]) {
        color = colors[color];
    }
    return (<NativeActivityIndicator {...props} color={color} style={[props.style, props.sx && sx(props.sx)]}/>);
}
export const ActivityIndicator = Indicator;
//# sourceMappingURL=activity-indicator.js.map